import { ApplicationState } from "../../app/store";

export const selectIsAuthenticated = (store: ApplicationState) => store.session?.isAuthenticated;
export const selectToken = (store: ApplicationState) => store.session?.token;
